import React from "react";
import "./ApplicationFormLoader.css";

export default function ApplicationFormLoader() {
  return (
    <div className="application-form-loader" role="status">
      <span className="application-form-loader__mark" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      <span className="application-form-loader__label">Loading your application</span>
    </div>
  );
}
